import gql from 'graphql-tag';

const CREATE_PROJECT = gql`
  mutation createProject($data: ProjectCreateInput!) {
    createProject(data: $data) {
      id
      name
      description
      owner {
        id
        name
        avatar {
          id
          key
        }
      }
      team {
        id
        name
        avatar {
          id
          key
        }
      }
      startDate
      endDate
      status
      priority
      createdAt
      updatedAt
    }
  }
`;

export default CREATE_PROJECT;
